import request from '@/utils/request'

// 游客-获取指定民宿旅馆的房间列表
export function Wx_GetHotelRoomList(data) {
  return request({
    url: '/sysGoods/list',
    method: 'post',
    data,
  })
}

export function listByStoreId(data) {
  return request({
    url: '/sysGoods/listByStoreId',
    method: 'post',
    data,
  })
}

// 新增订单
export function insertOrder(data) {
  return request({
    url: '/sysOrder/insert',
    method: 'post',
    data,
  })
}

// 获取订单列表
export function getOrderList(data) {
  return request({
    url: '/sysOrder/list',
    method: 'post',
    data,
  })
}

// 接收订单
export function updateOrder(data) {
  return request({
    url: '/sysOrder/update',
    method: 'post',
    data,
  })
}

// 新增评论
export function insertOrderComment(data) {
  return request({
    url: '/sysOrderComment/insert',
    method: 'post',
    data,
  })
}

// 评论列表
export function listOrderComment(data) {
  return request({
    url: '/sysOrderComment/list',
    method: 'post',
    data,
  })
}
// 获取分类
export function listTableCategory(data) {
  return request({
    url: '/sysGoodsCategory/list',
    method: 'post',
    data,
  })
}

// 游客端-获取我的订单列表
export function Wx_GetMyPreHotelPage(query) {
  return request({
    url: 'PreHotel/Wx_GetMyPreHotelPage',
    method: 'get',
    params: query,
  })
}

// 获取活动信息列表
export function WeGetRealInfoPage(query) {
  return request({
    url: 'RealInfo/WeGetRealInfoPage',
    method: 'get',
    params: query,
  })
}
